import { Auth } from 'aws-amplify';
import { useCallback, useState } from 'react';
import { batch, useDispatch } from 'react-redux';
import { useApolloClient } from '@apollo/client';

import { setAccessToken, setCognitoUser } from '../state/auth/actions';

const useLogout = () => {
  const dispatch = useDispatch();

  const client = useApolloClient();

  const [isLoading, setLoading] = useState(false);
  const [hasError, setError] = useState(false);

  const logout = useCallback(async () => {
    setLoading(true);
    setError(false);

    return new Promise((resolve, reject) => {
      Auth.signOut()
        .then(() => {
          batch(() => {
            dispatch(setCognitoUser(null));
            dispatch(setAccessToken(null));
          });

          client.cache.evict({ fieldName: 'getBook' });
          client.cache.evict({ fieldName: 'listBooks' });

          resolve();
        })
        .catch((err) => {
          setLoading(false);
          setError(true);
          reject(err);
        });
    });
  }, []);

  return {
    logout,
    isLoading,
    hasError,
  };
};

export default useLogout;
